const BlogsData = [
{
name: "The Daileigh",
description: "The Daileigh’s Ashleigh Hutchinson wants her readers to build their perfect closet.",
date: "17-March-2021",
image: "https://img.freepik.com/free-photo/shop-clothing-clothes-shop-hanger-modern-shop-boutique_1150-8886.jpg?t=st=1652625664~exp=1652626264~hmac=4189a2d5bb46ca54457a5e706fa54ee2f3d68f01f24f9be6c74a5f42ce683da1&w=740",
link: "https://thedaileigh.com/"

},


    {
        name: "The Fashion Guitar",
        description: "The Fashion Guitar is the online blog of Dutch-born Charlotte Groeneveld-Van Haren",
        date: "21-April-2022",
        image: "https://thefashionguitar.com/wp-content/uploads/2019/10/Thefashionguitar-for-Hilfiger-Collection-2.jpg",
        link: "https://thefashionguitar.com/"
        
        },


        {
            name: "One Dapper Street",
            description: "We often think of fashion blogs as exclusive to women, but fashion is for all genders",
            date: "12-June-2020",
            image: "https://i1.wp.com/onedapperstreet.com/redesign/wp-content/uploads/2020/09/ODS08250-2.jpg?resize=1050%2C700",
            link: "https://onedapperstreet.com/"
            
            },
    
]



export default BlogsData;